import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ACTION_ERROR_TITLE } from '../../interceptors/http-error.interceptor';
import type {
  CreateRemoteUserLocation,
  EditRemoteUserLocation,
  RemoteUserLocation,
} from '../../models/api/remote-user-location.model';

@Injectable({
  providedIn: 'root',
})
export class RemoteUserLocationService {
  private readonly httpClient = inject(HttpClient);
  private readonly api = `${environment.apiUrl}/v1/codebooks/remote-user-location`;

  getRemoteUserLocations(): Observable<RemoteUserLocation[]> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Remote User Locations',
    );

    return this.httpClient.get<RemoteUserLocation[]>(this.api, { context });
  }

  createRemoteUserLocation(
    remoteUserLocation: CreateRemoteUserLocation,
  ): Observable<RemoteUserLocation> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Create Remote User Location',
    );

    return this.httpClient.post<RemoteUserLocation>(this.api, remoteUserLocation, { context });
  }

  editRemoteUserLocation(
    id: number,
    remoteUserLocation: EditRemoteUserLocation,
  ): Observable<RemoteUserLocation> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Edit Remote User Location',
    );

    return this.httpClient.put<RemoteUserLocation>(`${this.api}/${id}`, remoteUserLocation, {
      context,
    });
  }

  deleteRemoteUserLocation(id: number): Observable<void> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Delete Remote User Location. Please make sure there are no users associated' +
        ' with this remote location',
    );

    return this.httpClient.delete<void>(`${this.api}/${id}`, { context });
  }
}
